import React from "react";
import ReactDOM from "react-dom";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import SignIn from "./views/SignIn/SignIn.jsx";
import DashboardLayout from "layouts/Dashboard";
import Dashboard from "./views/Dashboard/Dashboard.jsx";
import EmployeeApprovalList from "./views/Dashboard/EmployeeApprovalList.jsx";
import FormApprovalList from "./views/Dashboard/FormApprovalList.jsx";
import UserProfile from "views/UserProfile.jsx";
import Pan from "views/Pan/Pan.jsx";
import EmployeeList from "./views/Employee/EmployeeList.jsx";
import EmployeeDetails from "./views/Employee/EmployeeDetails.jsx";
import EmployeeForm from "./views/Employee/EmployeeForm.jsx";
import UserList from "./views/User/UserList.jsx";
import UserDetails from "./views/User/UserDetails.jsx";
import UserForm from "./views/User/UserForm.jsx";
import Form from "views/Form/Form.jsx";
import FormDetails from "views/Form/FormDetails.jsx";
import DatabaseList from "views/Database/DatabaseList/DatabaseList.jsx";
import DatabaseDetails from "views/Database/DatabaseDetails/DatabaseDetails.jsx";
import DatabaseForm from "views/Database/DatabaseForm/DatabaseForm.jsx";
import GeneralMemoList from "views/GeneralMemos/GeneralMemoList.jsx";
import MemoDetails from "views/GeneralMemos/MemoDetails.jsx";
import Payroll from "views/Payroll/Payroll.jsx";
import Report from "views/Report/Report.jsx";

import { getCredentials } from "./helpers/auth/storageAuth";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./assets/css/animate.min.css";
import "./assets/sass/light-bootstrap-dashboard-react.scss?v=1.3.0";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";
import "./assets/css/custom.css";

import { createBrowserHistory } from 'history';
const history = createBrowserHistory();

let signedIn;
function isSignedIn () {
  signedIn = getCredentials()
  return signedIn && signedIn.userId
}

ReactDOM.render(
  <Router history={history}>
    <Switch>
      <Route path='/signin' component={SignIn} />
      <Route
        path='/'
        render={(props) =>
          (isSignedIn()
            ? <DashboardLayout {...props}>
                <Switch>
                  <Route 
                    exact 
                    path='/' 
                    render={() =>
                      (<Redirect to='/dashboard' />)} />
                  <Route 
                    path='/dashboard' 
                    component={Dashboard} 
                    />
                  <Route 
                    path='/approvals/employees/list' 
                    component={EmployeeApprovalList} 
                    />
                  <Route 
                    path='/approvals/forms/list' 
                    component={FormApprovalList} 
                    />
                  <Route 
                    path='/profile'
                    render={(props) => <UserProfile {...props} user={signedIn} />}
                    />
                  <Route 
                    path='/pan' 
                    component={Pan} 
                    />
                  <Route
                    path='/employees/list'
                    component={EmployeeList}
                    />
                  <Route
                    path='/employees/create'
                    component={EmployeeForm}
                    />
                  <Route
                    path='/employees/edit/:id'
                    component={EmployeeForm}
                    />
                  <Route
                    path='/employees/details/:id'
                    component={EmployeeDetails}
                    />
                  <Route 
                    path='/users/list'
                    component={UserList}
                    />
                  <Route
                    path='/users/create'
                    component={UserForm}
                    />
                  <Route
                    path='/users/edit/:id'
                    component={UserForm}
                    />
                  <Route
                    path='/users/details/:id'
                    component={UserDetails}
                    />
                  <Route 
                    exact
                    path='/forms' 
                    component={Form} 
                    />
                  <Route
                    path='/forms/details/:formType/:id'
                    component={FormDetails}
                    />
                  <Route 
                    path='/database/list/:collection?/:id?' 
                    component={DatabaseList} 
                    />
                  <Route
                    path='/database/details/:collection/:id'
                    component={DatabaseDetails}
                    />
                  <Route
                    path='/database/:action/:collection/:id'
                    component={DatabaseForm}
                    />
                  <Route
                    path='/database/:action/:collection/:id?'
                    component={DatabaseForm}
                    />
                  <Route 
                    path='/general-memos/list' 
                    component={GeneralMemoList} 
                    />
                  <Route 
                    path='/general-memos/details/:id'
                    component={MemoDetails} 
                    />
                  <Route 
                    path='/payroll' 
                    component={Payroll} 
                    />
                  <Route 
                    path='/report' 
                    component={Report} 
                    />
                </Switch>
              </DashboardLayout>
            : <Redirect to='/signin' />)}
      />
    </Switch>
  </Router>,
  document.getElementById("root")
);
